import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

/**
 * Server-side safe version of MarketPrices
 * This component renders a loading state during server-side rendering
 */
export function ServerMarketPrices() {
  return (
    <div className="w-full">
      <div className="mb-6 flex justify-between items-center">
        <h2 className="text-3xl font-bold metal-text tracking-tight">Prezzi di Mercato</h2>
        <Button 
          variant="outline" 
          size="sm" 
          className="flex items-center gap-2 metal-border hover:bg-metal/10 transition-colors"
          disabled={true}
        >
          <RefreshCw className="h-4 w-4" /> 
          Aggiorna
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="overflow-hidden border-gold/20 shadow-md">
          <CardHeader className="bg-gradient-to-r from-gold/10 to-gold/5 pb-2">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-gold/20"></div>
                <h3 className="text-xl font-semibold text-gold">Oro</h3>
              </div>
              <div className="flex items-center gap-1">
                <Skeleton className="h-8 w-16" />
              </div>
            </div>
          </CardHeader>
          <CardContent className="p-4">
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-center">
                <Skeleton className="h-10 w-32" />
                <Skeleton className="h-6 w-20" />
              </div>
              <div className="flex justify-between items-center">
                <Skeleton className="h-5 w-24" />
                <Skeleton className="h-5 w-16" />
              </div>
            </div>
          </CardContent>
        </Card>
        
        <Card className="overflow-hidden border-silver/20 shadow-md">
          <CardHeader className="bg-gradient-to-r from-silver/10 to-silver/5 pb-2">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-silver/20"></div>
                <h3 className="text-xl font-semibold text-silver">Argento</h3>
              </div>
              <div className="flex items-center gap-1">
                <Skeleton className="h-8 w-16" />
              </div>
            </div>
          </CardHeader>
          <CardContent className="p-4">
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-center">
                <Skeleton className="h-10 w-32" />
                <Skeleton className="h-6 w-20" />
              </div>
              <div className="flex justify-between items-center">
                <Skeleton className="h-5 w-24" />
                <Skeleton className="h-5 w-16" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
